import styled from 'styled-components'

import { FireButton } from '@nx/fire/button'
import { Heading } from '@nx/fire/typography'

export const FollowCardContainer = styled.div`
  width: 100%;
`

export const StyledFireButton = styled(FireButton)`
  margin-bottom: -12px;
`

export const StyledHeading = styled(Heading)`
  margin-bottom: 10px;
`
